import api from './api';

export async function fetchSubscriptions({ lang = 'EN', platform = 'web' } = {}) {
  const response = await api.get('/subscription/get-subscriptions', {
    params: { lang, platform },
  });

  if (response.data?.error || response.data?.code !== 200) {
    throw new Error(response.data?.message || 'Unable to load subscriptions.');
  }

  return response.data?.dataset?.data || {};
}

export async function fetchQuizReattempts() {
  const response = await api.get('/subscription/get-quiz-reattempts');

  if (response.data?.error || response.data?.code !== 200) {
    throw new Error(response.data?.message || 'Unable to load reattempt packs.');
  }

  return response.data?.dataset?.data || {};
}

export async function fetchRapidFireReattempts() {
  const response = await api.get('/subscription/get-rapidfire-reattempts');

  if (response.data?.error || response.data?.code !== 200) {
    throw new Error(response.data?.message || 'Unable to load rapid fire attempts.');
  }

  return response.data?.dataset?.data || {};
}

export async function createAssessmentOrder(plan) {
  const planId = Number(plan?.id);
  const amount = Number(plan?.discounted_price || plan?.price);
  if (!Number.isInteger(planId) || planId <= 0 || !Number.isFinite(amount) || amount <= 0) {
    throw new Error('Select a valid assessment reattempt plan.');
  }
  const response = await api.post('/subscription/generate-order', {
    order_type: 'purchase-assessment-reattempts',
    quiz_reattempt_price_id: planId,
    amount: String(amount),
    currency: 'INR',
  });
  const body = response?.data || {};
  if (body.error || body.code !== 200) {
    throw new Error(body.message || 'Unable to create assessment reattempt order.');
  }
  const order = body.dataset?.data || {};
  if (!order.vk_order_id) throw new Error('The server did not return an order ID.');
  return order;
}
